import { render, staticRenderFns } from "./TutorialVideo.vue?vue&type=template&id=36e1945c&scoped=true&"
import script from "./TutorialVideo.vue?vue&type=script&lang=js&"
export * from "./TutorialVideo.vue?vue&type=script&lang=js&"
import style0 from "./TutorialVideo.vue?vue&type=style&index=0&id=36e1945c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e1945c",
  null
  
)

export default component.exports